import { NgModule } from '@angular/core';

import * as ApiServiceProxies from './service-proxies';
import * as urlInfo from './url-info';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        urlInfo.UrlInfoService
    ]
})
export class ServiceProxyModule { }


// WEBPACK FOOTER //
// D:/OficinaVirtual/FrontEndFinnecta/EFactoringManager/src/shared/service-proxies/service-proxy.module.ts